import useRouteParser from 'src/hooks/routeParser'
import { FiveThresholdsConfig } from 'src/types/api/order-bot'
import { RouteParamValue, RouteRecordRawArgumented } from 'src/types/route'

const { toArrayOfInt, toBoolean, toInt, toObject } = useRouteParser()

const module: RouteRecordRawArgumented = {
  path: ':step?',
  name: 'orderBotCompose',
  component: () =>
    import(
      /* webpackChunkName: "order-bot-compose" */ 'pages/order-bot/ComposePage.vue'
    ),
  meta: {
    casts: {
      query: {
        class: toArrayOfInt,
        manufacturer: toArrayOfInt,
        only_stock_zero: toBoolean,
        package_tolerance: toInt,
        order_package: toObject,
        shuttles_disabled: toObject,
        include_new: toBoolean,
        include_forced: toBoolean,
        warehouses_from_disabled: toObject,
        warehouses_to_disabled: toObject,
        warehouses_virtual: toObject,
        created_from: toInt,
        logistics_classes: toObject,
        sorts: toObject,
        transfer_package: toObject,
        cpa_visible: toObject,
        routine: toInt,
        discounts: toObject,
        five_thresholds: (value) => {
          const data = toObject<FiveThresholdsConfig>(value)

          if (data.cdv_range[1] == null) {
            data.cdv_range[1] = undefined
          }

          return data as unknown as RouteParamValue
        },
        orders_destinations: toObject,
        phantom_order: toBoolean,
      },
    },
    inject: {
      params: {
        step: 'general',
      },
    },
    encode: {
      query: {
        order_package: JSON.stringify,
        shuttles_disabled: JSON.stringify,
        logistics_classes: JSON.stringify,
        // sorts: (value) => {
        //   return value ? JSON.stringify(Object.values(value)) : value
        // },
        sorts: JSON.stringify,
        transfer_package: JSON.stringify,
        warehouses_from_disabled: JSON.stringify,
        warehouses_to_disabled: JSON.stringify,
        warehouses_virtual: JSON.stringify,
        cpa_visible: JSON.stringify,
        discounts: JSON.stringify,
        five_thresholds: JSON.stringify,
        orders_destinations: JSON.stringify,
      },
    },
  },
}

export default module